// extracted by mini-css-extract-plugin
module.exports = {"Keypad":"Keypad_Keypad__2TTIA","Row":"Keypad_Row__3wDvA","DarkMode":"Keypad_DarkMode__2Fhv6"};